import React, { FormEvent, useContext, useState } from "react";
import {
  Button,
  Form,
  Grid,
  Input,
  Select,
  Tab,
  Table,
} from "semantic-ui-react";
import { IWarehouseLog } from "../../../app/models/warehouselog";
import TransmissionStore from "../../../app/stores/transmissionStore";
import MaterialEditForm from "./MaterialEditForm";
import { observer } from "mobx-react-lite";
const MaterialTab = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmission,
    warehouselogsByName,
    warehousesByName,
    warehouseRegistry,
    selectedWarehouselog,
    selectWarehouselog,
    createWarehouseLog,
    loadWarehouseLogs,
    deleteWarehouseLog,
    submitting,
    editMode,
    target,
  } = transmissionStore;

  const initializeForm: IWarehouseLog = {
    id: "0",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    orderNo: "",
    partNo: "",
    name: "",
    uom: "",
    quantity: 0,
    stock: 0,
    status: "",
    pickedBy: "",
    assignedTo: "",
    url: "",
    remark: "",
  };

  const [warehouselog, setWarehouseLog] = useState<IWarehouseLog>({
    id: "0",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    orderNo: "",
    partNo: "",
    name: "",
    uom: "",
    quantity: 0,
    stock: 0,
    status: "",
    pickedBy: "",
    assignedTo: "",
    url: "",
    remark: "",
  });

  const warehouseOptions = warehousesByName.map((warehouse) => {
    var option = {
      key: warehouse.id,
      text: warehouse.name,
      value: warehouse.id,
    };
    return option;
  });

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setWarehouseLog({ ...warehouselog, [name]: value });
  };

  const handleSubmit = () => {
    let warehouselogs: IWarehouseLog[] = new Array();
    warehouselogs.push(warehouselog);
    warehouselog.name &&
      createWarehouseLog(warehouselogs)
        .then(() => loadWarehouseLogs(warehouselog.projectId))
        .then(() => initializeForm && setWarehouseLog(initializeForm));
  };

  return (
    <Tab.Pane clearing>
      <Grid>
        <Grid.Column>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Field inline>
                <label>Serial Number</label>
                <Input
                  onChange={handleInputChange}
                  name="partNo"
                  placeholder="Serial Number"
                  value={warehouselog.partNo}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Material Name</label>
                <Select
                  required
                  search
                  onChange={(e, { value }) => {
                    const warehouse = warehouseRegistry.get(value);
                    setWarehouseLog({
                      ...warehouselog,
                      name: warehouse.name,
                      stock: Number(warehouse.stock),
                      partNo: warehouse.partNo,
                    });
                  }}
                  options={warehouseOptions}
                  name="name"
                  placeholder="Material Name"
                />
              </Form.Field>
              <Form.Field inline>
                <label>Quantity</label>
                <Input
                  onChange={handleInputChange}
                  name="quantity"
                  placeholder="Quantity"
                  value={warehouselog.quantity}
                />
              </Form.Field>

              <Form.Field inline>
                <Button
                  loading={submitting}
                  floated="right"
                  positive
                  type="submit"
                  content="Add"
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Serial Number</Table.HeaderCell>
            <Table.HeaderCell>Material Name</Table.HeaderCell>
            <Table.HeaderCell>Quantity</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {warehouselogsByName.map((warehouselog) => (
            <Table.Row key={warehouselog.id}>
              <Table.Cell>{warehouselog.partNo}</Table.Cell>
              <Table.Cell>{warehouselog.name}</Table.Cell>
              <Table.Cell>{warehouselog.quantity}</Table.Cell>
              {/* <Table.Cell>{warehouselog.remark}</Table.Cell> */}
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    onClick={() => {
                      selectWarehouselog(warehouselog.id);
                    }}
                    size="mini"
                    content="Edit"
                    color="blue"
                  />
                  <Button
                    name={warehouselog.id}
                    size="mini"
                    loading={target === warehouselog.id && submitting}
                    onClick={(e) => deleteWarehouseLog(e, warehouselog.id)}
                    content="Delete"
                    color="red"
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      {selectedWarehouselog && editMode && <MaterialEditForm />}
    </Tab.Pane>
  );
};

export default observer(MaterialTab);
